module.exports = __webpack_public_path__ + "img/payslipPdf.11741f7d.svg";